import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { setToLocalStorage, showSuccessToast } from "src/lib/utils";
import { OtpInput } from "reactjs-otp-input";
import { Button } from "./ui/button";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { sendOtp, verifyOtp } from "src/api/auth";
import { useAuth } from "src/providers/AuthProvider";
import { useTimer } from "use-timer";

const OTPForm = () => {
	const { setUser } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

	const { time, reset, start, status } = useTimer({
		initialTime: 60,
		endTime: 0,
		timerType: "DECREMENTAL",
		autostart: true,
	});

	const email = location.state?.email || "";

	useEffect(() => {
		if (!email) {
			navigate("/signup");
		}
	}, [email, navigate]);

	const { mutate, isLoading } = useMutation(verifyOtp, {
		onSuccess: ({ data, message }) => {
			showSuccessToast(message);

			const user = data.user;
			setUser(user);

			const access_token = data.access_token;
			setToLocalStorage("access_token", access_token);

			navigate("/dashboard");
		},
	});
	const { mutate: sendOTP, isLoading: isSendingOTP } = useMutation(sendOtp, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			reset();
			start();
		},
	});

	const initialValues = {
		email,
		otp: "",
	};
	const validationSchema = Yup.object().shape({
		email: Yup.string().email().required("Email is required"),
		otp: Yup.string().length(6, "OTP must be 6 characters long").required("OTP is required"),
	});

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, setFieldValue, handleSubmit }) => (
				<form onSubmit={handleSubmit} className="tw-grid tw-gap-4 tw-max-w-[450px]">
					<div>
						<OtpInput
							value={values.otp}
							onChange={(value) => setFieldValue("otp", value)}
							numInputs={6}
							shouldAutoFocus
							containerStyle={{ display: "grid", gap: 10, gridTemplateColumns: "repeat(6,1fr)" }}
							inputStyle={{
								paddingInline: 10,
								paddingBlock: 15,
								border: "1px solid #7e7c7c",
								fontSize: "16px",
								width: "100%",
								borderRadius: 10,
							}}
							focusStyle={{
								borderColor: "#008080",
							}}
						/>
						<ErrorMessage name="otp" component="div" className="tw-block tw-mt-1 tw-text-xs tw-text-destructive" />
					</div>

					<Button variant="secondary" className="tw-w-full" disabled={isLoading}>
						{isLoading ? "Verifying..." : "Continue"}
					</Button>

					<p className="resendText">
						Didn’t receive the code? You can resend the code in{" "}
						{status === "RUNNING" ? (
							<span>{time}s</span>
						) : (
							<button className="tw-text-primary" type="button" disabled={isSendingOTP} onClick={() => sendOTP({ email })}>
								Resend
							</button>
						)}
					</p>
				</form>
			)}
		</Formik>
	);
};

export default OTPForm;
